import React, { useEffect, useState } from "react";
import style from "css/device.module.css";
import Warranty from "./warranty";
import Shoppingmall from "./shoppingmall";
import Consult from "./consult";
import Experience from "./experience";
import SEOMeta from "components/app/SEOMeta";
import Questions from "components/app/questions";

function Frame(props) {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 767);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 767);

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <SEOMeta
        title="neat.frame, 리브테크놀로지"
        description="리브테크놀로지 riv Technology - neat.frame"
        keywords="리브테크놀로지, 리브테크, 리브, riv, riv Technology, neat, frame, neat frame, 화상회의"
      />
      <div className={style.device_title_wrap}>
        <div className={style.device_subtitle}>
          <span>최초의 세로형</span> 비디오 디바이스
        </div>
        <div className={style.device_title}>
          <img
            className={style.small_title}
            src={
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/title_neat_frame${isMobile ? "_m" : ""}.webp`
            }
            alt="frame"
          />
        </div>
      </div>
      <div className={style.device_text}>
        가상 리셉셔니스트 및{isMobile ? <br /> : " "}소규모 회의실 / 개인용
        화상회의 장비
      </div>

      <div className={style.device_img_list}>
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/frame_1${isMobile ? "_m" : ""}.webp`
          }
          alt="frame"
        />
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/frame_2${isMobile ? "_m" : ""}.webp`
          }
          alt="frame"
        />
        <img
          src={
            `${process.env.REACT_APP_CLIENT_URL}` +
            `img/device/neat/frame_3${isMobile ? "_m" : ""}.webp`
          }
          alt="frame"
        />
      </div>

      <div className={style.device_description_wrap}>
        <div
          className={style.device_description_img_box}
          style={{
            paddingTop: "0px",
            justifyContent: "center",
            paddingBottom: isMobile && "0px",
          }}
        >
          <div
            className={style.device_description_img_wrap}
            style={{ gap: "99px" }}
          >
            {isMobile ? (
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  "img/device/neat/frame_reddot_m.webp"
                }
                alt="frame"
              />
            ) : (
              <>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    "img/device/neat/frame_device.webp"
                  }
                  alt="frame"
                />
                <div className={style.device_description_reddot_wrap}>
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/device/neat/reddot_2021.webp"
                    }
                    alt="reddot"
                  />
                  <img
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      "img/device/neat/reddot_2022.webp"
                    }
                    alt="reddot"
                  />
                </div>
              </>
            )}
          </div>
        </div>
        <div className={style.device_description_list_wrap}>
          <div className={style.device_description_list}>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/device${isMobile ? "_m" : ""}.webp`
                  }
                  alt="device"
                />
              </div>
              <div className={style.device_description_text}>
                <span>최초의 15.6인치</span> All-in-One 퍼스널 디바이스
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/edit${isMobile ? "_m" : ""}.webp`
                  }
                  alt="edit"
                />
              </div>
              <div className={style.device_description_text}>
                시간과 공간에 대한{" "}
                <span>제약이 없으며 문서 공유와 편집이 가능</span>
              </div>
            </div>
            <div className={style.device_description_list_item}>
              <div className={style.device_description_icon_box}>
                <img
                  src={
                    `${process.env.REACT_APP_CLIENT_URL}` +
                    `img/device/neat/setting${isMobile ? "_m" : ""}.webp`
                  }
                  alt="setting"
                />
              </div>
              <div className={style.device_description_text}>
                <span>누구나</span> 쉽게 설치하고 간편한 설정 및 작동 가능
              </div>
            </div>
          </div>

          <div className={style.device_support_platform_wrap}>
            <div className={style.device_support_platform_title_wrap}>
              <div className={style.device_support_platform_horizon}></div>
              <div className={style.device_support_platform_title}>
                지원 플랫폼
              </div>
            </div>
            <div className={style.device_support_platform_list}>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_zoom_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/zoom_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="zoom"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>ZOOM</span>
                </div>
              </div>
              <div className={style.device_support_platform_list_item}>
                <div className={style.device_support_platform_img_wrap}>
                  <img
                    className={style.support_teams_logo_img}
                    src={
                      `${process.env.REACT_APP_CLIENT_URL}` +
                      `img/device/neat/teams_logo${isMobile ? "_m" : ""}.webp`
                    }
                    alt="teams"
                  />
                </div>

                <div className={style.device_support_platform_name}>
                  <span>Microsoft Teams</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className={style.device_vertical_line_wrap}>
        <div className={style.device_vertical_line}></div>
      </div>

      <div className={style.device_features_wrap}>
        <div className={style.device_features_title}>
          Neat Frame <span>특장점</span>
        </div>
        <div className={style.device_features_list}>
          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              {/* <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_frame_1${isMobile ? "_m" : ""}.webp`
                }
                alt="feature1"
              /> */}
              <video
                autoPlay={true}
                muted={true}
                loop={true}
                controls={false}
                src={`${process.env.REACT_APP_CLIENT_URL}video/feature_frame_1.mp4`}
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"1".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  화상회의의 새로운 방식
                </div>
              </div>
              <div className={style.device_features_text}>
                {
                  "[ 임원실, 로비, 다목적 공간, 소규모 인원 ]\n개인이 활용하기에 매우 편리한 터치스크린 디바이스 입니다."
                }
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_frame_2.webp`
                }
                alt="feature2"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"2".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  공간 절약형 디바이스
                </div>
              </div>
              <div className={style.device_features_text}>
                {`15.6 인치의 세로 화면은 상대적으로 작은 공간을 차지하며,${
                  isMobile ? " " : "\n"
                }` +
                  `개인의 필요나 선호도에 따라 쉽게 이동이 가능합니다.${
                    isMobile ? " " : "\n"
                  }` +
                  `자율좌석에 최적화 된 사이즈 및 성능 입니다.`}
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_frame_3${isMobile ? "_m" : ""}.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"3".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>키오스크</div>
              </div>
              <div className={style.device_features_text}>
                {
                  "사람들이 방문하는 주요 공간에 키오스크를 만들어 사내 정보 공유, 맵 공유,\n담당자와 영상 통화 등을 제공합니다."
                }
              </div>
            </div>
          </div>

          <div className={style.device_features_list_item}>
            <div className={style.device_features_img_wrap}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/feature_frame_4${isMobile ? "_m" : ""}.webp`
                }
                alt="feature3"
              />
            </div>
            <div className={style.device_features_text_wrap}>
              <div className={style.device_features_label_wrap}>
                <div className={style.device_features_item_index}>
                  {"4".padStart(2, "0")}
                </div>
                <div className={style.device_features_item_label}>
                  더 뛰어난 기능, 더 만족스러운 회의
                </div>
              </div>
              <div className={style.device_features_text}>
                {`앉아 있든 · 서 있든 · 움직이든 상관없이 고해상도 113도 시야각과${
                  isMobile ? " " : "\n"
                }` +
                  `4배 줌으로 자동 플레임을 잡아줍니다.\n\n대규모 회의에서 보다 직접적인 대화를 가능하게 하고${
                    isMobile ? " " : "\n"
                  }` +
                  `뛰어난 밝기로 모든 표정이나 몸짓을 포착합니다.`}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Experience />

      <div className={style.device_spec_wrap}>
        <div className={style.device_spec_title}>제품 사양</div>

        <div className={style.device_size_img_wrap}>
          <div className={style.device_img_wrap}>
            <img
              src={
                `${process.env.REACT_APP_CLIENT_URL}` +
                `img/device/neat/spec_frame_1${isMobile ? "_m" : ""}.webp`
              }
              alt="spec1"
            />
          </div>
          <div className={style.device_spec_img_wrap}>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_frame_2${isMobile ? "_m" : ""}.webp`
                }
                alt="spec2"
              />
            </div>
            <div className={style.device_spec_img_box}>
              <img
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/spec_frame_3${isMobile ? "_m" : ""}.webp`
                }
                alt="spec3"
              />
            </div>
          </div>
        </div>

        <div className={style.device_spec_text_wrap}>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "67px" }}
            >
              <div className={style.device_spec_text_label}>일반</div>
              <div className={style.device_spec_text}>
                <span>15.6인치 정전식 멀티 터치 LED 화면</span>
                <span>450 NITS 화면</span>
                <span>해상도 1080x1920, 60Hz</span>
                <span>9:16 화면비</span>
                <span>눈부심 방지 및 지문 방지 코팅</span>
                <span>카메라 LED</span>
                <span>시스템 LED</span>
                <span>주변광 센서</span>
                <span>깊이 센서</span>
                <span>온도, 습도, 공기질 센서</span>
                <span>삼각대 나사산(1/4-20 UNC)</span>
                <span>프라이버시 셔터</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "40px" }}
            >
              <div className={style.device_spec_text_label}>비디오</div>
              <div className={style.device_spec_text}>
                <span>4배 디지털 줌</span>
                <span>50MP 캡처 해상도</span>
                <span>113° 수평 시야</span>
                <span>자동 인물 프레이밍</span>
                <span>인물 비디오 해상도: 최대 1080p/30</span>
                <span>콘텐츠 비디오 해상도: 720p/60 , 1080p / 30</span>
              </div>
            </div>
          </div>
          <div className={style.device_spec_text_group}>
            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "46px" }}
            >
              <div className={style.device_spec_text_label}>
                네트워크 & 포트
              </div>
              <div className={style.device_spec_text}>
                <span>WiFi</span>
                <span>Bluetooth</span>
                <span>AC 전원(내부 전원 공급 장치)</span>
                <span>USB-C (이더넷 및 악세서리 연결 가능)</span>
                <span>3.5mm 4핀 미니 잭</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "144px" }}
            >
              <div className={style.device_spec_text_label}>오디오</div>
              <div className={style.device_spec_text}>
                <span>양방향 라우드스피커</span>
                <span>1개의 트래킹 마이크</span>
                <span>3개의 빔포밍 마이크</span>
                <span>유선 및 무선 헤드폰 지원</span>
                <span>하드웨어 가속 오디오 처리</span>
                <span>에코 제거</span>
                <span>소음 억제</span>
                <span>자동 게인 컨트롤</span>
              </div>
            </div>

            <div
              className={style.device_spec_text_item}
              style={{ gap: isMobile ? "20px" : "87px" }}
            >
              <div className={style.device_spec_text_label}>크기 및 무게</div>
              <div className={style.device_spec_text}>
                <span>너비: 222.5mm(8.8인치)</span>
                <span>높이: 445mm(17.5인치)</span>
                <span>깊이: 111.2mm(4.4인치)</span>
                <span>무게: 3.45kg(7.6파운드)</span>
              </div>
            </div>
          </div>
        </div>

        <div
          className={style.device_spec_icon_wrap}
          style={{
            backgroundImage:
              "url(" +
              `${process.env.REACT_APP_CLIENT_URL}` +
              `img/device/neat/spec_frame_bg${isMobile ? "_m" : ""}.webp)`,
          }}
        >
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>15.6”</div>
            <div className={style.device_spec_icon_label}>
              15.6인치 터치 스크린
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>450</div>
            <div className={style.device_spec_icon_label}>450 KNIT 화면</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>8x</div>
            <div className={style.device_spec_icon_label}>8배 디지털 줌</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>113°</div>
            <div className={style.device_spec_icon_label}>113° 수평시야각</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>50 MP</div>
            <div className={style.device_spec_icon_label}>50MP 캡처 해상도</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.woofer_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/woofer${isMobile ? "_m" : ""}.webp`
                }
                alt="woofer"
              />
            </div>
            <div className={style.device_spec_icon_label}>트위터 & 우퍼</div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.micArray3_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/mic_array_3${isMobile ? "_m" : ""}.webp`
                }
                alt="mic"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              3개 마이크 어레이
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon}>
              <img
                className={style.headphone_icon}
                src={
                  `${process.env.REACT_APP_CLIENT_URL}` +
                  `img/device/neat/headphone${isMobile ? "_m" : ""}.webp`
                }
                alt="headphone"
              />
            </div>
            <div className={style.device_spec_icon_label}>
              유/무선 헤드폰{isMobile ? <br /> : " "}연결가능
            </div>
          </div>
          <div className={style.device_spec_icon_item}>
            <div className={style.device_spec_icon_text}>Sensors</div>
            <div className={style.device_spec_icon_label}>
              깊이·온도·습도·공기 품질 센서
            </div>
          </div>
        </div>

        <Warranty />
      </div>

      <Shoppingmall type="frame" />

      {props.type === "popup" ? (
        <div style={{ marginBottom: "70px" }}>
          <Consult />
        </div>
      ) : (
        <div className={style.device_consult_wrapper}>
          <Questions />
        </div>
      )}
    </>
  );
}

export default Frame;
